import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Field } from '../../UI';

/**
 * Endereço do cliente (AW2-1136 Etapa 2) — porta de `EnderecoCliente.jsx`
 * real, endereço ÚNICO (não lista — sem "Adicionar Endereço", sem
 * "Principal", diferente de `EnderecoDevedor.jsx`), sempre somente-leitura.
 */
export default function EnderecoCliente({ endereco }) {
  return (
    <>
      <Typography variant="h3" sx={{ mt: 3, mb: 1.5 }}>Endereço:</Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr) minmax(0, 1fr)', md: 'repeat(4, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="CEP:" value={endereco?.cep ?? ''} disabled />
        <Field label="Endereço:" value={endereco?.endereco ?? ''} disabled />
        <Field label="Número:" value={endereco?.numero ?? ''} disabled />
        <Field label="Complemento:" value={endereco?.complemento ?? ''} disabled />
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr) minmax(0, 1fr)', md: 'repeat(3, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          mt: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="Bairro:" value={endereco?.bairro ?? ''} disabled />
        <Field label="Cidade:" value={endereco?.cidade ?? ''} disabled />
        <Field label="Estado:" value={endereco?.estado ?? ''} disabled />
      </Box>
    </>
  );
}

EnderecoCliente.propTypes = {
  endereco: PropTypes.shape({
    cep: PropTypes.string,
    endereco: PropTypes.string,
    numero: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    complemento: PropTypes.string,
    bairro: PropTypes.string,
    cidade: PropTypes.string,
    estado: PropTypes.string,
  }),
};

EnderecoCliente.defaultProps = {
  endereco: null,
};
